import React from 'react';
import PropTypes from 'prop-types';
import FormDetalhePessoa from './pessoa';
import FormDetalhePessoaJuridica from './pessoaJuridica';
import FormDetalheEndereco from './endereco';
import * as S from './styles';
import { ENUM_TIPO_PESSOA } from 'utils/consts';

export default function FormDetalheDadosCadastrais({ dados, endereco }) {
  return (
    <>
      <FormDetalhePessoa dados={dados} />
      {dados?.tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao && (
        <>
          <S.Titulo marginTop={'50px'}>Dados Profissionais</S.Titulo>
          <FormDetalhePessoaJuridica dados={dados} />
        </>
      )}
      <S.Titulo marginTop={'50px'}>Endereço</S.Titulo>
      <FormDetalheEndereco dados={endereco} />
    </>
  );
}
FormDetalheDadosCadastrais.propTypes = {
  dados: PropTypes.object,
};
